import client from '../../client/funDetailClient';
import funDetailDataClient from '../../client/funDetailDataClient';
import dictClient from '../../client/dictClient';
export default class Model {
    public resultData = null;
    public ajaxLoginData = null;

    
    public async save(params: any) {
        const result = await client.save(params);
        if (result) {
            return result;
        } else {
            return null;
        }
    }

    public async removeByIds(params: any) {
        const result = await client.removeByIds(params);
        if (result) {
            return result;
        } else {
            return null;
        }
    }

    public async updateById(params: any) {
        const result = await client.updateById(params);
        if (result) {
            return result;
        } else {
            return null;
        }
    }
    public async getById(params: any) {
        const result = await client.getById(params);
        if (result) {
            return result;
        } else {
            return null;
        }
    }

    public async selectPageData(params: any) {
        const result = await client.selectPageData(params);
        if (result) {
            return result;
        }
    }

    // 查询属性数据表
    public async selectDetailDataByDetailId(params: any) {
        const result = await funDetailDataClient.selectByDetailId(params);
        if (result) {
            return result;
        }
    }

    
    // 码表查询
    public async selectDictPageData(params: any) {
        const result = await dictClient.selectPageData(params);
        if (result) {
            return result;
        }
    }

    
    public async queryOrderIsBad(params: any) {
        const result = await client.queryOrderIsBad(params);
        if (result) {
            return result;
        }
    }

    public async updateOrderNoGoFront(params: any) {
        const result = await client.updateOrderNoGoFront(params);
        if (result) {
            return result;
        }
    }
    
    public async updateOrderNoGoAfter(params: any) {
        const result = await client.updateOrderNoGoAfter(params);
        if (result) {
            return result;
        }
    }
    
}
